<template>
    <div class="staffs-license-assign">
        <licences :licenses="licenses" :versionedLicenses="versionedLicenses" />
        <h3 class="mt-4">
            {{ $l10n.__('Attribution des licences') }}
        </h3>
        <p
            class="m-0 fs-3 lh-big"
            v-html="
                $t.__(
                    'sellsyaccountmanager.SubscriptionManager.Staffs.licence_count_on_account',
                    total,
                )
            "
        ></p>
        <p class="grey m-0 fs-3 lh-big">
            {{
                $l10n.__(
                    'Attribuez les en fonction des besoins de vos collaborateurs afin qu’ils puissent utiliser les différents modules proposés dans Sellsy.',
                )
            }}
        </p>

        <div class="flex-row br staff-form-container fs-3 p-2 mt-3 gray-0-bkg">
            <span class="semibold mr-3">
                {{ $l10n.__('%s collaborateurs au total', pagination.total) }}
            </span>
            <CompassButton
                :label="$t.__('sellsyaccountmanager.SubscriptionManager.Staffs.add_staff')"
                type="primary"
                @click="openPopup"
            />
        </div>
        <TableLoading v-if="isTableLoading" />
        <CompassTable v-else size="large" maxHeight="60%" class="staffs-license-assign__table">
            <CompassTableHead :isFixed="true">
                <CompassTableHeadCell>{{ $t.__('common.labels.name') }} </CompassTableHeadCell>
                <CompassTableHeadCell>
                    {{ $t.__('sellsyaccountmanager.SubscriptionManager.Staffs.job_title') }}
                </CompassTableHeadCell>
                <CompassTableHeadCell>
                    {{ $t.__('common.labels.licence_type') }}
                </CompassTableHeadCell>
            </CompassTableHead>
            <CompassTableBody>
                <CompassTableRow v-for="staff in staffs" :key="staff.id">
                    <CompassTableBodyCell>
                        <CompassAvatar v-bind="formatUserToCompassAvatar(staff)" size="small" />
                        <span class="ml-2 semibold">
                            {{ staff.firstname + ' ' + staff.lastname }}
                        </span>
                    </CompassTableBodyCell>
                    <CompassTableBodyCell>
                        <span class="darkgrey">{{ staff.position }}</span>
                    </CompassTableBodyCell>
                    <CompassTableBodyCell maxWidth="232px" minWidth="232px">
                        <template v-if="availableLicenses.length">
                            <div
                                v-if="staff.loading"
                                class="select-loader compass-input compass-input--disabled compass-input--medium"
                            >
                                <div class="select-loader__loader"></div>
                                <span class="select-loader__message">
                                    {{ $t.__('common.labels.allocation_in_progress') }}
                                </span>
                                <CompassIcon icon="caret-down" />
                            </div>
                            <CompassSelect
                                v-else
                                :modelValue="staff.license"
                                class="staffs-license-assign__select-license"
                                @update:modelValue="updateLicense($event, staff)"
                            >
                                <CompassDropdownOption
                                    v-for="license in availableLicenses"
                                    :key="license.value"
                                    :disabled="license.disabled"
                                    :label="license.label"
                                    :value="license.value"
                                />
                            </CompassSelect>
                        </template>
                    </CompassTableBodyCell>
                </CompassTableRow>
            </CompassTableBody>
        </CompassTable>
        <TablePagination
            v-if="pagination.total > 0"
            :pagination="pagination"
            :isLoading="false"
            class="listing-wrapper__pagination"
            @update-pagination="fetchStaffs"
        />
    </div>
</template>

<script>
import Licences from 'vcomponents/sellsyaccountmanager/Licences.vue';
import { createNamespacedHelpers } from 'vuex';
import TablePagination from 'vcomponents/common/table/TablePagination.vue';
import TableLoading from 'vcomponents/common/table/TableLoading.vue';
import { formatUserToCompassAvatar } from 'Helpers/avatarHelper';

const { mapState, mapActions } = createNamespacedHelpers('subscriptionManager');
const { mapState: mapStateUser } = createNamespacedHelpers('user');
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;
export default {
    components: {
        TableLoading,
        TablePagination,
        Licences,
    },
    data() {
        return {
            loading: [],
            labels: {
                empty: this.$l10n.__('Aucun collaborateur créé pour le moment'),
            },
            pagination: {
                limit: 25,
                offset: '',
                total: 0,
                currentPage: 1,
            },
            isTableLoading: false,
        };
    },
    computed: {
        ...mapState({
            availableLicenses(state) {
                return state.availableLicenses;
            },
            versionedLicenses(state) {
                return state.versionedLicenses;
            },
            licenses(state) {
                return state.licenses;
            },
            /**
             * Return array of the list of staff users
             */
            staffs(state) {
                return state.staffs.map((staff, index) => {
                    staff.loading = this.loading[index];
                    staff.license = staff.license === null ? 'null' : staff.license;
                    return staff;
                });
            },
            total: function (state) {
                if (state.licenses.length === 0) {
                    return 0;
                }
                return state.licenses.reduce(
                    (accumulator, license) => accumulator + license.total,
                    0,
                );
            },
        }),
        ...mapStateUser({
            staffId: 'id',
        }),
    },
    created() {
        this.fetchStaffs(this.pagination);
    },
    methods: {
        formatUserToCompassAvatar,
        ...popupPanelMapActions(['open']),
        ...mapActions(['addStaffs', 'setLicenseForStaff']),

        /**
         * Open a popup throught call of open() from popupPanel.js
         */
        openPopup() {
            this.open({
                key: 'staffForm',
                props: {
                    message: window.i18n.__(
                        'Vous souhaitez ajouter un collaborateur à votre compte Sellsy ?',
                    ),
                    title: window.i18n.__('Ajouter un collaborateur'),
                },
            });
        },
        updateLicense(value, staff) {
            const index = this.staffs.map((staff) => staff.id).indexOf(staff.id);
            this.loading.splice(index, 1, true);
            this.setLicenseForStaff({
                staffId: staff.id,
                licenseId: value === 'null' ? null : value,
            })
                .then(() => {
                    this.loading.splice(index, 1, false);
                    if (staff.id === this.staffId) {
                        EventBus.emit('assignSelfLicense', value);
                    }
                })
                .catch(() => {
                    this.$pushToast({
                        type: 'error',
                        message: this.$l10n.__(
                            'Une erreur est survenue, merci de réessayer plus tard',
                        ),
                        icon: true,
                    });
                    this.loading.splice(index, 1, false);
                });
        },
        fetchStaffs(pagination) {
            this.isTableLoading = true;
            this.addStaffs(pagination)
                .then(({ data }) => {
                    this.pagination = data.pagination;
                    this.loading = Array.from(data.data, () => false);
                })
                .catch(() => {
                    this.$pushToast({
                        type: 'error',
                        message: this.$l10n.__(
                            'Une erreur est survenue, merci de réessayer plus tard',
                        ),
                        icon: true,
                    });
                })
                .finally(() => {
                    this.isTableLoading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.el-table:before {
    content: none;
}
.staff-form-container {
    justify-content: right;
    align-items: center;
}

.staffs-license-assign {
    &__no-result {
        margin-top: var(--spacing-5);
    }
    &__table:deep() {
        margin-top: var(--spacing-3);
        .compass-table-head th {
            background-color: var(--colors-common-background-default);
            color: var(--colors-common-text-standard-default);
        }
        .staffs-license-assign__select-license {
            width: 200px;
        }
    }

    .select-loader {
        align-items: center;
        display: flex;
        justify-content: space-between;
        width: 200px;

        &__loader {
            -webkit-animation: spin 2s linear infinite; /* Safari */
            animation: spin 2s linear infinite;
            background-color: transparent;
            border: 2px solid var(--colors-common-border-darker);
            border-bottom: 2px solid var(--colors-common-background-default);
            border-radius: 50%;
            height: 16px;
            width: 16px;
        }
    }
}

/* Safari */
@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
